module.exports = __webpack_public_path__ + "img/video-snippet.735d6ba0.svg";